module.exports = __webpack_public_path__ + "img/97.020d1966.jpg";